class navInternal {
    constructor(container, items, callback) {
        this.container = container; // This is the <ul> element
        this.items = Array.from(items);
        this.navLinks = [];

        this.buildNavItems();
        this.setupScrollListener();

        if (typeof callback === 'function') {
            callback();
        }
    }

    slugify(text) {
        return text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '');
    }

    buildNavItems() {
        this.items.forEach(item => {
            const title = item.getAttribute('data-navstop');
            const id = this.slugify(title);
            item.id = id;

            const li = document.createElement('li');
            li.classList.add('list-nav-internal-item');

            const a = document.createElement('a');
            a.classList.add('link-internal');
            a.href = `#${id}`;
            a.textContent = title;

            li.appendChild(a);
            this.container.appendChild(li);
            this.navLinks.push({ link: li, target: item });
        });
    }

    setupScrollListener() {
        let currentActive = null;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let newActive = null;

                    this.navLinks.forEach(({ link, target }) => {
                        const isActive = target === entry.target;
                        link.classList.toggle('active', isActive);
                        if (isActive) newActive = link;
                    });

                    if (newActive !== currentActive) {
                        currentActive = newActive;
                        window.dispatchEvent(new Event('native.intNavUpdated'));
                    }
                }
            });
        }, {
            rootMargin: '0px 0px -69% 0px',
            threshold: 0.1
        });

        this.navLinks.forEach(({ target }) => observer.observe(target));
    }

}

export { navInternal };